import { WorkExperienceRole, WorkExperienceBullet, WorkExperienceCompany } from '@applicator/shared'

import { setBulletsIncluded } from '../../../utils/workExperienceInclusion'

// Helper function to toggle role field included state
export function toggleRoleFieldIncluded(role: WorkExperienceRole, field: 'positionIncluded' | 'locationIncluded'): WorkExperienceRole {
  if (field === 'positionIncluded') {
    const nextPositionIncluded = !(role.positionIncluded ?? true)
    if (!nextPositionIncluded) {
      return {
        ...role,
        positionIncluded: false,
        included: false,
        bulletPoints: setBulletsIncluded(role.bulletPoints, false),
      }
    }
    return {
      ...role,
      positionIncluded: true,
      included: true,
    }
  }
  return { ...role, [field]: !(role[field] ?? true) }
}

// Helper function to toggle single bullet point
export function toggleSingleBullet(bullet: WorkExperienceBullet, bulletId: string): WorkExperienceBullet {
  if (bullet.id !== bulletId) return bullet
  return { ...bullet, included: !bullet.included }
}

// Helper function to get role bullet points
export function getRoleBulletPoints(role: WorkExperienceRole): WorkExperienceBullet[] {
  return role.bulletPoints || []
}

// Helper function to check if role matches ID
export function isRoleMatchingId(role: WorkExperienceRole, roleId: string): boolean {
  return role.id === roleId
}

// Helper function to update single role field
export function updateSingleRoleField(role: WorkExperienceRole, roleId: string, field: 'position' | 'location' | 'employmentType' | 'startDate' | 'endDate', value: string): WorkExperienceRole | null {
  if (role.id !== roleId) return null
  return { ...role, [field]: value }
}

// Helper function to check if bullet matches ID for update
export function isBulletMatchingIdForUpdate(bullet: WorkExperienceBullet, bulletId: string): boolean {
  return bullet.id === bulletId
}

// Helper function to update bullet text
export function updateBulletText(bullet: WorkExperienceBullet, text: string): WorkExperienceBullet {
  return { ...bullet, text }
}

// Helper function to normalize date value
export function normalizeDateValue(date: string): string {
  return date === 'N/A' || date === 'Not set' ? '' : date
}

// Helper function to check if date is Present
export function isPresentDate(date: string): boolean {
  return date === 'Present'
}

// Helper function to find bullet in role
export function findBulletInRole(role: WorkExperienceRole, bulletId: string): WorkExperienceBullet | undefined {
  return (role.bulletPoints || []).find((b) => b.id === bulletId)
}

// Helper function to find bullet in company
export function findBulletInCompany(company: WorkExperienceCompany, bulletId: string): WorkExperienceBullet | undefined {
  for (const role of company.roles || []) {
    const bullet = findBulletInRole(role, bulletId)
    if (bullet) return bullet
  }
  return undefined
}
